import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faArrowsH,
  faBullseye,
  faFireExtinguisher,
  faHandHoldingBox,
  faStickyNote,
  faTruckLoading,
  faWrench,
} from '@fortawesome/pro-light-svg-icons'

import { SquareIconWithBackground } from '@domain-group/suit-theme'

import useOrderItemTaskType from '@hooks/useOrderItemTaskType'

const TASK_ICONS = {
  clean: faFireExtinguisher,
  deliver: faTruckLoading,
  install: faArrowUp,
  move: faArrowsH,
  other: faBullseye,
  overlay: faStickyNote,
  pickup: faHandHoldingBox,
  remove: faArrowDown,
  repair: faWrench,
}

type TaskIconProps = {
  height?: number,
  taskTypeId: number,
  width?: number,
  variant?: string,
}

const TaskIcon = (props: TaskIconProps) => {
  const {
    height = 30, taskTypeId, width = 30, variant,
  } = props

  const { orderItemTaskType, taskColor } = useOrderItemTaskType({ id: taskTypeId })

  // @ts-expect-error TS2538
  const icon = TASK_ICONS[orderItemTaskType.short_name] || faWrench

  if (variant === 'light'){
    return (
      <FontAwesomeIcon icon={icon} style={{ color: `#${taskColor}`, fontSize: 14 }} />
    )
  }

  return (
    <SquareIconWithBackground
      backgroundColor={`#${taskColor}1a`}
      height={height}
      width={width}
      icon={<FontAwesomeIcon icon={icon} style={{ color: `#${taskColor}`, fontSize: 16 }} />}
    />
  )
}

export default TaskIcon
